export default __webpack_public_path__ + "assets/BrandDocument.81d6.svg";